import { render } from "./Article.vue?vue&type=template&id=6800d6dd&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=6800d6dd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6800d6dd"]])

export default __exports__